import React from 'react';
import Spinner from '@atlassian/jira-common-components-spinner';
import { JiraContextContainer } from '@atlassian/jira-context-container';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries';
import { GlobalBottomRightCornerContainer } from '@atlassian/jira-layout-controller';
import PlanConfluenceEmbed from '@atlassian/jira-portfolio-3-portfolio/src/app-confluence-macro';
import { useReportInitialChecks } from '@atlassian/jira-portfolio-3-portfolio/src/app-confluence-macro/view/main-new/common/services/use-report-initial-checks';
import { getQueryParameters } from '@atlassian/jira-portfolio-3-portfolio/src/common/window';
import { ErrorScreen } from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui';
import { AsyncEmbeddedLoginPage } from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/error-screens/embedded-login/async';
import { useLocale } from '@atlassian/jira-tenant-context-controller';
import UFOSegment from '@atlassian/jira-ufo-segment';

const FOOTER_OFFSET_PX = 48;

const PlanConfluenceEmbedWrapper = () => {
	const { r: reportId } = getQueryParameters();
	const locale = useLocale();

	const { loading, error, data } = useReportInitialChecks(reportId);

	if (error?.statusCode === 401) {
		return <AsyncEmbeddedLoginPage />;
	}

	if (loading || data == null) {
		return <Spinner />;
	}

	if (!data.success) {
		return <ErrorScreen errorMessage={data.errorMessage} planId={data.planId} isEmbedded />;
	}

	return (
		<UFOSegment name="plan-confluence-embed-app">
			<JSErrorBoundary
				id="spa-app.advanced-roadmaps-plan.embed-report"
				packageName="jiraSpaAppsAdvancedRoadmapsPlan"
				teamName="advanced-roadmaps"
			>
				<JiraContextContainer>
					<PlanConfluenceEmbed locale={locale} />
					<GlobalBottomRightCornerContainer bottomOffset={FOOTER_OFFSET_PX} />
				</JiraContextContainer>
			</JSErrorBoundary>
		</UFOSegment>
	);
};

export default PlanConfluenceEmbedWrapper;
